/**
 * Search-folding for user-typed filters: lowercase, Serbian diacritics and
 * đ/Đ stripped ("Šabac" → "sabac", "Đorđe" → "djordje"), so typing without
 * diacritics on a tablet keyboard still matches.
 */
export function foldText(s: string): string {
  return s
    .replace(/đ/g, "dj")
    .replace(/Đ/g, "dj")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/** True when every whitespace-separated word of `query` occurs in `text` (folded). */
export function matchesQuery(text: string, query: string): boolean {
  const q = foldText(query);
  if (!q) return true;
  const t = foldText(text);
  return q.split(/\s+/).every((w) => t.includes(w));
}
